import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ItemMinWidth extends BaseOption {
  static userInterfaceComponent = {
    label: "Item Min Width",
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      inputType: "number",
      min: 0,
      append: "px",
    },
  };

  static defaultValue = 250;
}
